 
<div class="modal-cont" *ngIf="isModalVisible">
  <div class="row">
    <div class="col-md-6">
      <div class="card" style="width: 450px; height: auto; border-radius: 15px ">
        <div class="card-body">
          <h2>Share </h2> 
            <button id="closeBtn" style=" border-radius: 50px;
            float: right;
            margin-top: -38px;
        " type="button" class="close" aria-label="Close" (click)="close()">X
          </button>
          </div>
          <div class="modal-body">
          <div class="social_profile">
            <ul>
              <li class="col-md-" >
                <a href="javascript:void(0)"  (click)="shareOnFacebook()">
                  <img alt="facebook" src="./assets/facebooknew.png" style="width:50px ; margin-left: -20px;"/>
                </a>
              </li>
              <li class="col-md-">
                <a href="javascript:void(0)"  (click)="shareOnTwitter()">
                  <img alt="twitter" src="./assets/twitternew.png" style="width:48px ; margin-top: -1px; margin-left: 11px;" />
                </a>
              </li>
              <li class="col-md-2">
                <a href="javascript:void(0)"  (click)="shareOnLinkedIn()">
                  <img alt="linkedin" src="./assets/linkedinnew.png" style="width:42px ; margin-top: 8px; margin-left: 14px;" />
                </a>
              </li>
              <li class="col-md-">
                <a href="javascript:void(0)"  (click)="shareOnWhatsapp()">
                  <img alt="linkedin" src="./assets/whatsappnew.png" style="width:41px ; margin-top: 8px; margin-left: 4px;" />
                </a>
              </li>
              <li class="col-md-">
                <a href="javascript:void(0)"  (click)="shareOnEmail()">
                  <img alt="linkedin" src="./assets/emailnew.png" style="width:40px ; margin-top: 9px; margin-left: 18px; " />
                </a>
              </li>

              <li class="col-md-">
                <a href="javascript:void(0)"  (click)="copyLinks()"  *ngIf="!copySuccess">
                  <img alt="Copy to Clipboard" src="./assets/copypng.png" style="width:41px ; margin-top: 8px; margin-left: 19px;" />
                </a>
                <a href="javascript:void(0)"  (click)="copyLinks()" *ngIf="copySuccess"> 
                  <img alt="Link Copied"  src="./assets/copied.png" style="width:44px ; margin-top: 7px;  margin-left: 19px;" />
                </a>
              </li>
            </ul>
            <div><ul style="font-size: 11px;">
              <li style="margin-top: -18px; margin-left: -17px;">Facebook</li>
              <li style="margin-top: -18px; margin-left: 16px;">Twitter</li>
              <li style="margin-top: -18px; margin-left: 23px;">Linkedin</li>
              <li style="margin-top: -18px; margin-left: 13px;">Whatsapp</li>
              <li style="margin-top: -18px; margin-left: 20px;">Email</li>
              <li style="margin-top: -18px; margin-left: 20px;" *ngIf="!copySuccess">Copy Link</li>
              <li style="margin-top: -18px; margin-left: 28px;" *ngIf="copySuccess">Copied</li>
            </ul></div>
          </div> 
        </div> 
      </div>
    </div>

  </div>
</div>
 
 